import * as React from "react";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { TaskRequestStatus } from "../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { ReportInfo } from "../../../Wrap/Models/Models/Reports/ReportInfo";
import { DocumentFileAction } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Document/Action/DocumentFileAction";
import { TableColSettingsStore } from "../TableColFilter/Store/Variable";
import { ExcelExportAction } from "./Actions/ExcelExportAction";
import { ExcelExportStore } from "./Store/Variable";

export interface IExcelExportButtonProps {
    onRequestReport: Function;
    selectedAccount: string;
}
export interface IExcelExportButtonState {
    isPending?: boolean;
    isCompleted?: boolean;
    reportInfo?: ReportInfo;
    url?: string;
}
export class ExcelExportButton extends BaseComponent<IExcelExportButtonProps, IExcelExportButtonState> {
    constructor(props: any) {
        super(props);
        this.state = { isPending: false, isCompleted: false };
        this.subscribeToStore(ExcelExportStore, () => this.onStoreChange());
        this.subscribeToStore(TableColSettingsStore, () => this.onTableColSettingsStoreChange());
    }

    private onStoreChange() {
        if (ExcelExportStore.getActionType() == ActionType.Success) {
            const data = ExcelExportStore.getData();
            this.setState({ reportInfo: data, isPending: true, isCompleted: false });
            ExcelExportAction.getTaskRequestStatus(data.TaskRequestID.toString());
        }
        if (ExcelExportStore.getActionType() == ActionType.Update) {
            const status = ExcelExportStore.getStatus();
            if (
                status == TaskRequestStatus.Pending ||
                status == TaskRequestStatus.Running ||
                status == TaskRequestStatus.Allocated ||
                status == TaskRequestStatus.PendingDelayed ||
                status == TaskRequestStatus.PendingHold
            ) {
                setTimeout(() => {
                    ExcelExportAction.getTaskRequestStatus(this.state.reportInfo.TaskRequestID.toString());
                }, 2000);
            } else if (status == TaskRequestStatus.Complete) {
                DocumentFileAction.get(
                    this.props.selectedAccount,
                    this.state.reportInfo.FileName,
                    true,
                    0,
                    this.state.reportInfo.TaskRequestID,
                    null,
                    (result: string) => {
                        this.setState({
                            isPending: false,
                            isCompleted: true,
                            url: result,
                        });
                    },
                    true
                );
            } else {
                //failed or cancelled, need confirm with SC
            }
        }
    }

    private onTableColSettingsStoreChange() {
        this.setState({
            isPending: false,
            isCompleted: false,
            url: null,
        });
    }

    public render(): JSX.Element {
        return (
            <>
                {!this.state.isPending && !this.state.isCompleted && (
                    <button
                        type="button"
                        className="excel-download"
                        title="Export to Excel"
                        onClick={() => {
                            this.setState({ isPending: true, isCompleted: false });
                            this.props.onRequestReport();
                        }}
                    >
                        <span className="icon" aria-hidden="true"></span>
                        <span className="sr-only">Export to excel</span>
                    </button>
                )}
                {this.state.isPending && (
                    <>
                        <div className="lds-dual-ring">
                            <span className="sr-only" role="status">
                                Generating file, please wait.
                            </span>
                        </div>
                    </>
                )}
                {this.state.isCompleted && (
                    <>
                        <div>
                            <span role="status" className="sr-only">
                                Generating file complete.
                            </span>
                            <a
                                role="link"
                                tabIndex={0}
                                href={this.state.url}
                                onClick={() => {
                                    this.setState({ isPending: false, isCompleted: false });
                                }}
                            >
                                Download
                            </a>
                        </div>
                    </>
                )}
            </>
        );
    }
}
